import { Chat } from "@launch10/use-langgraph-stream";
import { CHAT_PERSONAS } from "@components/chat/chatPersonas";
import { useWebsiteStreamOptions, useWebsitePagesSync, useAutoSelectNewPage, useWebsiteComposer } from "@hooks/website";
import { ChatProvider } from "@components/shared/chat/ChatProvider";
import { usePage } from "@inertiajs/react";
import { useCallback } from "react";
import { analytics } from "@lib/analytics";
import { useCreditGateProps } from "@hooks/shared";
import BuildStep from "@components/website/steps/BuildStep";

interface WebsitePageProps {
  project?: { id?: number; uuid?: string };
  [key: string]: unknown;
}

/**
 * Website page — the build substep (with its inline domain picker) under a
 * Chat.Root for the website graph. Build is the only — and terminal — website
 * substep; the standalone /domain and /deploy steps were folded into it
 * (inline DomainPicker + DeployPill in the build toolbar).
 */
export default function Website() {
  const { project } = usePage<WebsitePageProps>().props;
  const streamOptions = useWebsiteStreamOptions();
  const useComposer = useWebsiteComposer();
  const creditGate = useCreditGateProps();

  const handleSubmit = useCallback((sendMessage: () => void) => {
    if (project?.uuid) {
      analytics.trackProject("website_edited", project.uuid, {
        edit_type: "chat_iteration",
      });
    }
    sendMessage();
  }, [project?.uuid]);

  return (
    <Chat.Root streamOptions={streamOptions} useComposer={useComposer} onSubmit={handleSubmit} personas={CHAT_PERSONAS} {...creditGate}>
      <ChatProvider name="website" syncKeys={["websiteId", "projectId"]} />
      <WebsitePagesSyncEffect />
      <AutoSelectNewPageEffect />
      <BuildStep />
    </Chat.Root>
  );
}

function WebsitePagesSyncEffect() {
  useWebsitePagesSync();
  return null;
}

function AutoSelectNewPageEffect() {
  useAutoSelectNewPage();
  return null;
}
